export default __webpack_public_path__ + "static/media/AboutGianna.cddb2d47.jpg";